import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { jsPDF } from "jspdf";
import { useReactToPrint } from "react-to-print";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import toast, { Toaster } from "react-hot-toast";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import CircularProgress from "@mui/material/CircularProgress";
import { useDownloadExcel } from "react-export-table-to-excel";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
    getItemDetailKeyValuePair,
    getSalesOrderByCustomerId1,
    getSalesOrderBySalesPersonId1,
    getSalesOrderByItemId1,
    getPurchaseOrderByVendorId1,
    getPurchaseOrderByItemId1,
    getBillByVendorId1,
    getInvoiceDetailReport1,
    getBelowOrderLevelItemReport1,
    getBelowOrderLimitSetPointReport,
    getRecordByDepartmentId1,
    getInventorySummary1,
    getWarehouseKeyValueList,
    getBatchesReport,
    getIssuanceReport,
    getHsnKeyValuePair,
    getCategoryKeyValue,
    itemPriceListReport,
    purchaseProjectionReport,
    issueReport,
    grnReport,
    stockReport,
    deficitReport,
    departmentKeyValue1,
    getOrgById,
    getOrgKeyValue,
    getCustomerList,
    getPriceKeyValuePair,
} from "../../services/index";
import { searchForMatch } from "../utils/textUtils";
import SalesByCustomer from "./SalesByCustomer";
import SalesByItem from "./SalesByItem";
import SalesByInvoice from "./SalesByInvoice";
import PurchaseByVendor from "./PurchaseByVendor";
import InventorySummary from "./InventorySummary";
import RecordsByDepartment from "./RecordsByDepartment";
import ProductionSummary from "./ProductionSummary";
import ReportStockClosing from "./ReportStockClosing";
import IssuanceReport from "./IssuanceReport";
import HSNReport from "./HSNReport";
import {
    getHSNReport,
    getPurchaseReport,
    getSalesMarginReport,
} from "../../services/Sales/SalesOrderService";
import BelowReorderPoint from "./BelowReorderPoint";
import BelowOrderLimitReport from "./BelowOrderLimitReport";
import PurchaseReport from "./PurchaseReport";
import Loader from "../Common/Loader";
import ItemPriceList from "./ItemPriceList";
import PurchaseProjection from "./PurchaseProjection";
import IssueReport from "./IssueReport";
import GrnReport from "./GrnReport";
import SalesMarginReport from "./SalesMarginReport";
import StockReport from "./StockReport";
import StockTransferReports from "./StockTransferReports";
import { AuthUrlContext } from "../../context/createContext";
import DeficitReport from "./DeficitReport";
import {
    pendingPurchaseOrderByVendor,
    pendingSalesOrderByCustomer,
    customerPriceList,
    vendorPriceList,
    SalesByCreditNotes,
    consumptionVsCurrentStock,
    HsnReport,
    CreditHsnReport,
    PalleteOccupacyReports,
    getOrderVsDispatch,
    getCustomSales,
    getMonthlySalesByCustomer,
    getMonthlySoldItemsWithQuantity,
    getCustomerFssaiReports,
    getCustomerCategoryDiscountReport,
} from "../../services/Report/ReportServices";
import CustomerPriceListReport from "./CustomerPriceListReport";
import VendorPriceListReport from "./VendorPriceListReport";
import PendingSalesOrderByCustomer from "./PendingSalesOrderByCustomer";
import PendingPurchaseOrderByVendor from "./PendingPurchaseOrderByVendor";
import { nonMovingItemReport, requisitionReport, stockHistory, stockTransferByItemReport, stockTransferReport, wipReport } from "../../services/Purchase/Reports";
import StockTransferByItem from "./StockTransferByItem";
import NonMovingItems from "./NonMovingItems";
import WIPReport from "./WipReport";
import WipReport from "./WipReport";
import { callGetAxios } from "../../services/common/common";
import { CUSTOMER_CATEGORY_URL, CUSTOMER_URL, GET_WAREHOUSE_BY_ORG_ID, SUB_CATEGORY_URL } from "../../CONSTANTS";
import SalesByCreditNotesReport from "./SalesByCreditNotesReport";
import ConsumptionReport from "./ConsumptionReport";
import HReport from "./Hreport";
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import RequisitionReport from "./RequisitionReport";
import CRHSN from "./crhsn";
import PalleteOccupancy from "./PalleteOccupancy";
import { storeOptionsByWarehouseId } from "../../services/Purchase/StoreService";
import { SalesCustom } from "./SalesCustom";
import OrdersVsDispatch from "./OrdersVsDispatch";
import FgItemsReport from "./FgItemsReport";
import { GetFgItemsReports } from "../../services/Inventory/ItemService";
import MonthlySalesByCustomer from "./MonthlySalesByCustomer";
import MonthlySoldItems from "./MonthlySoldItems";
import StockHistory from "./StockHistory";
import CustomerFssaiReport from "./CustomerFssaiReport";
import CustomerCategoryDiscountReport from "./CustomerCategoryDiscountReport";

const ViewReports = () => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    const [reportOptionsList, setReportOptionsList] = useState([]);
    const orgDetail = JSON.parse(localStorage.getItem("orgDetail"));
    const { name } = useParams();
    const [reportName, setReportName] = useState("SalesByCustomer");
    const [item, setItem] = useState({
        label: "Select Item",
        value: "",
    });
    const [itemOptions, setItemOptions] = useState("");
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [resPacket, setResPacket] = useState([]);
    const [targetDate, setTargetDate] = useState(date1)
    const [startDate, setStartDate] = useState(date1);
    const [endDate, setEndDate] = useState(date1);
    // Non Moving Items uses a "Last N days" filter instead of a calendar range
    const nonMovingDaysOptions = [
        { label: "Last 15 Days", value: 15 },
        { label: "Last 30 Days", value: 30 },
        { label: "Last 45 Days", value: 45 },
        { label: "Last 60 Days", value: 60 },
        { label: "Last 90 Days", value: 90 },
    ];
    const [nonMovingDays, setNonMovingDays] = useState({ label: "Last 30 Days", value: 30 });
    const getNonMovingRange = () => {
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - (nonMovingDays?.value || 30));
        return {
            startDate: start.toISOString().substring(0, 10),
            endDate: end.toISOString().substring(0, 10),
        };
    };
    const [ware, setWare] = useState(
        {
            label: "Mohra",
            value: "09200fc5-69dd-4d0c-8da3-8ac42ff79c64",
        }
    );
    const [wareOptions, setWareOptions] = useState("");
    // Sales Margin Report: only the logged-in organisation's own warehouses (e.g. La Pyramid -> Kesri, Mohra, Corporate Office, Saha)
    const [marginWareOptions, setMarginWareOptions] = useState([]);
    const [fromWare, setFromWare] = useState({ label: "All", value: "All" });
    const [toWare, setToWare] = useState({ label: "All", value: "All" });
    const [multiware, setMultiware] = useState([]);
    const [multiWareOptions, setMultiWareOptions] = useState("");
    const [dept, setDept] = useState("");
    const [deptOptions, setDeptOptions] = useState("");
    const [org, setOrg] = useState("");
    const [selectWarehouse, setSelectWarehouse] = useState(true);
    const [selectDepartment, setSelectDepartment] = useState(true);
    const [orgOptions, setOrgOptions] = useState("");
    const [printDiv, setPrintDiv] = useState(false);
    const [hsnOptions, setHsnOptions] = useState([]);
    const [hsn, setHsn] = useState({
        label: "Select HSN",
        value: "",
    });
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    // Sales Margin Report: multi-select categories (empty = all)
    const [marginCategories, setMarginCategories] = useState([]);
    const [subCategoryOptions, setSubategoryOptions] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const navigate = useNavigate();
    const [storeOption, setStoreOptions] = useState([])
    const [selectedStore, setSelectedStore] = useState()
    const { userRights } = useContext(AuthUrlContext);
    const { urlList, userRole } = userRights;
    const [customerListOptions, setCustomerListOptions] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState({ label: "All", value: "All" })
    const [customerCategoryOptions, setCustomerCategoryOptions] = useState([])
    const [selectedCustomerCategory, setSelectedCustomerCategory] = useState({ label: "All", value: "All" })
    const isSuperAdmin = userRole === "ROLE_SUPER_ADMIN";
    const [priceListOpt, setPriceListOpt] = useState([])
    const [selectedPrice, setSelectedPrice] = useState({
        label: "All",
        value: ""
    })

    useEffect(() => {
        if (name) {
            handleReportType(name)
            setReportName(name)
        } else {
            setReportName('SalesByCustomer')
        }
        customerAllRecords();
        customerCategoryAllRecords();
    }, [name])

    // useEffect(() => {
    //   if (isSuperAdmin) {
    //     setReportOptionsList(reportOptions);
    //     const reportName = reportOptions[0]?.reportTypes[0]?.name;
    //     setReportName(reportName);
    //   } else {
    //     const _reportOptions = reportOptions.filter((reports) => {
    //       const temp = reports.reportTypes.filter((report) => {
    //         if (urlList.has(report.serverUrl)) {
    //           return report;
    //         }
    //       });
    //       if (temp.length) {
    //         return temp;
    //       }
    //     });
    //     if (_reportOptions.length === 0) {
    //       navigate("/");
    //       return;
    //     }
    //     setReportOptionsList(_reportOptions);
    //     const reportName = _reportOptions[0]?.reportTypes[0]?.name;
    //     setReportName(reportName);
    //   }
    // }, [isSuperAdmin, urlList.size]);
    const customerCategoryAllRecords = async () => {
        try {
            const res = await callGetAxios(CUSTOMER_CATEGORY_URL() + "getKeyValueList");
            if (res.errorCode === 0) {
                setCustomerCategoryOptions(
                    res.responsePacket
                        // blank titled categories would show up as an empty row in the dropdown
                        .filter((d) => d.key && d.value && d.value.trim())
                        .map((d) => ({ value: d.key, label: d.value }))
                );
            }
        } catch (error) {
            console.error(error);
        }
    };

    const customerRecordsByCategory = async (customerCategoryUuid) => {
        try {
            const res = await callGetAxios(
                CUSTOMER_URL() + "getKeyValueListByCustomerCategory/" + customerCategoryUuid
            );
            if (res.errorCode === 0) {
                setCustomerListOptions(
                    res.responsePacket.map((d) => ({ value: d.key, label: d.value }))
                );
            } else {
                setCustomerListOptions([]);
                toast(res.message);
            }
        } catch (error) {
            console.error(error);
            setCustomerListOptions([]);
        }
    };

    const customerAllRecords = () => {
        var request = {
            page: 0,
            search: "",
            size: -1,
        };
        getCustomerList(request).then((response) => {
            if (response.errorCode === 0) {
                const arr = [];
                response.responsePacket.data.map((data) =>
                    arr.push({
                        value: data.recordId,
                        label: data.title,
                    })
                );
                setSelectedCustomer(arr[0]);
                setCustomerListOptions(arr);
                {/* TODO - uncomment */ }
                // setSelectedCustomer(arr[0]);
            } else {
                toast(response.message);
            }
        });
    };



    useEffect(() => {
        if ((reportName !== "RequisitionReport" && reportName !== "monthlySoldItems" && reportName !== "monthlySalesByCustomer" && reportName != "IssueReports" && reportName !== "PurchaseReports" && reportName !== "ProductionSummary" && reportName !== "SalesMarginReport") && ware?.value === "All") {
            setWare(
                {
                    label: "Mohra",
                    value: "09200fc5-69dd-4d0c-8da3-8ac42ff79c64",
                }
            )
        }

    }, [reportName, ware?.value])

  
    useEffect(() => {
        const getSubCategoryKeyValue = async () => {
            try {
                const rUrl = SUB_CATEGORY_URL() + "getKeyValueList"
                const res = await callGetAxios(rUrl)
                if (res.errorCode === 0) {
                    const options = (res.responsePacket || []).map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    options.unshift({
                        value: null,
                        label: "All",
                    });
                    setSelectedSubCategory(options[0])
                    setSubategoryOptions(options);
                }

            } catch (error) {
                console.error(error)
            }
        }
        getSubCategoryKeyValue()

        getCategoryKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = (res.responsePacket || []).map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                options.unshift({
                    value: null,
                    label: "All",
                });
                setCategoryOptions(options);
                setSelectedCategory(options[0]);
            }
        });
        getPriceKeyValuePair().then((res) => {
            const options = res.responsePacket.map((d) => ({
                value: d.key,
                label: d.value,
            }));
            options.unshift({
                value: "",
                label: "All",
            });
            setPriceListOpt(options);
            setSelectedPrice(options[0]);
        })
    }, []);
    useEffect(() => {
        // Inventory Summary builds its own store list from the multi-warehouse selection (effect below).
        if (reportName === "InventorySummary") return;
        if (ware?.value && ware?.value !== "All") {
            storeOptionsByWarehouseId(ware?.value).then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setStoreOptions(options);
                    if (options.length > 0) {
                        setSelectedStore(options[0])
                    }
                    else {
                        setSelectedStore("")
                    }

                } else {
                    toast.error(res.message)
                }
            });
        }
    }, [ware, reportName])

    // Inventory Summary store filter: stores of the single selected warehouse, plus "All Stores" and
    // "Unassigned" (batch rows that were never given a store). Locked when 0 or 2+ warehouses are selected.
    useEffect(() => {
        if (reportName !== "InventorySummary") return;
        const allStores = { label: "All Stores", value: "" };
        if (multiware.length !== 1) {
            setStoreOptions([allStores]);
            setSelectedStore(allStores);
            return;
        }
        storeOptionsByWarehouseId(multiware[0].value).then((res) => {
            if (res.errorCode === 0) {
                const options = (res.responsePacket || []).map((d) => ({ value: d.key, label: d.value }));
                setStoreOptions([allStores, ...options, { label: "Unassigned (no store)", value: "unassigned" }]);
            } else {
                setStoreOptions([allStores]);
                toast.error(res.message);
            }
            setSelectedStore(allStores);
        });
    }, [multiware, reportName])

    useEffect(() => {
        if (ware?.value && storeOption.length > 0 && selectedStore && selectedStore?.value) {
            if (reportName === "palleteOccupacy") {
                setLoading(true)
                PalleteOccupacyReports({ storeId: selectedStore?.value }).then((res) => {
                    handleApiResponse(res.responsePacket.data)
                })

            }
        }
        else if (reportName === "palleteOccupacy") {
            handleApiResponse([])
        }
    }, [selectedStore, reportName])
    
    useEffect(() => {
        if (reportName === "customerFssai") {
            setLoading(true)
            getCustomerFssaiReports().then((res) => {
                handleApiResponse(res.responsePacket.data)
            })
        }
        if (reportName === "customerCategoryDiscount") {
            setLoading(true)
            getCustomerCategoryDiscountReport().then((res) => {
                handleApiResponse(res.responsePacket.data)
            })
        }

    }, [reportName])
    



    useEffect(() => {
        getItemDetailKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    label: d.value,
                    value: d.key,
                }));
                options.unshift({
                    label: "Select Item",
                    value: "",
                });
                setItemOptions(options);
            } else {
                toast(res.message);
            }
        });

        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWare(options[0]);
                setWareOptions(options);
                setMultiware([options[0]]);
                setMultiWareOptions(options);
            }
        });

        departmentKeyValue1().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setDept(options[0]);
                setDeptOptions(options);
            } else {
                toast(res.message);
            }
        });

        getOrgKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setOrg(options[0]);
                setOrgOptions(options);
            } else {
                toast(res.message);
            }
        });

        getHsnKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                options.unshift({
                    label: "Select HSN",
                    value: "",
                });
                setHsnOptions(options);
            }
        });
    }, []);

    const handlePrint = () => {
        setPrintDiv(true);
        setTimeout(() => {
            handleReactToPrint();
        }, 1000);

        setTimeout(() => {
            setPrintDiv(false);
        }, 6000);
    };

    const componentRef = useRef();
    const handleReactToPrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // True only while the Excel file is being built; reports can hide screen-only columns from the export.
    const [excelExport, setExcelExport] = useState(false);

    const handlePrintExcel = () => {
        setPrintDiv(true);
        setExcelExport(true);
        setTimeout(() => {
            onDownload();
        }, 1000);

        setTimeout(() => {
            setPrintDiv(false);
            setExcelExport(false);
        }, 6000);
    };

    const { onDownload } = useDownloadExcel({
        currentTableRef: componentRef.current,
        filename: "Users table",
        sheet: "Users",
    });

    const handleSearchData = (s) => {
        let arr1 = rows.filter((a) => {
            return (
                searchForMatch(a.billDate, s) ||
                searchForMatch(a.vendorName, s) ||
                searchForMatch(a.phoneNumber, s) ||
                searchForMatch(a.email, s) ||
                searchForMatch(a.payment_term_title, s) ||
                searchForMatch(a.state, s) ||
                searchForMatch(a.zipCode, s) ||
                searchForMatch(a.country, s) ||
                searchForMatch(a.state, s) ||
                searchForMatch(a.hsnSac, s) ||
                searchForMatch(a.creditNumber, s) ||
                searchForMatch(a.invoiceNumber, s) ||
                searchForMatch(a.customerCategory, s) ||
                searchForMatch(a.creditNoteDate, s) ||
                searchForMatch(a.customerName, s) ||
                searchForMatch(a.placeOfSupply, s) ||
                searchForMatch(a.priceList, s) ||
                searchForMatch(a.salesOrderDate, s) ||
                searchForMatch(a.purchaseOrderDate, s) ||
                searchForMatch(a.invoiceDate, s) ||
                searchForMatch(a.billNo, s) ||
                searchForMatch(a.orderNo, s) ||
                searchForMatch(a.purchaseOrderNo, s) ||
                searchForMatch(a.invoiceNo, s) ||
                searchForMatch(a.salesOrderNo, s) ||
                searchForMatch(a.customerTitle, s) ||
                searchForMatch(a.warehouseTitle, s) ||
                searchForMatch(a.itemTitle, s) ||
                searchForMatch(a.category, s) ||
                searchForMatch(a.subCategory, s) ||
                searchForMatch(a.issuedByUserTitle, s) ||
                searchForMatch(a.issuedDepartmentTitle, s) ||
                searchForMatch(a.issuedToUserTitle, s) ||
                searchForMatch(a.vendorTitle, s) ||
                searchForMatch(a.customerName, s) ||
                searchForMatch(a.customerCategory, s) ||
                searchForMatch(a.itemName, s) ||
                searchForMatch(a.orderNo, s) ||
                searchForMatch(a.customerTitle, s) ||
                searchForMatch(a.customerCategory, s) ||
                searchForMatch(a.itemTitle, s) ||
                searchForMatch(a.purchaseNumber, s) ||
                searchForMatch(a.purchaseDate, s) ||
                searchForMatch(a.supplierCategory, s) ||
                searchForMatch(a.city, s) ||
                searchForMatch(a.supplierName, s) ||
                searchForMatch(a.state, s) ||
                searchForMatch(a.itemCode, s) ||
                searchForMatch(a.supplierName, s) ||
                searchForMatch(a.grnNoBillNumber, s) ||
                searchForMatch(a.requisitionNumber, s) ||
                searchForMatch(a.grnDate, s) ||
                searchForMatch(a.departMant, s) ||
                searchForMatch(a.issueDate, s) ||
                (a.hsnSac && searchForMatch(a.hsnSac, s)) ||
                (a.batchItemsList && searchForMatch(a.batchItemsList[0]?.itemTitle, s)) ||
                (a.batchItemsList && searchForMatch(a.batchItemsList[0]?.batchName, s)) ||
                (a.batchItemsList && searchForMatch(a.batchItemsList[0]?.batchNo, s)) ||
                searchForMatch(a.productionDate, s) ||
                searchForMatch(a.rackTitle, s) ||
                searchForMatch(a.cellTitle, s) ||
                searchForMatch(a.palletTitle, s) ||
                searchForMatch(a.batchNumber, s) ||
                searchForMatch(a.grnNo, s) ||
                searchForMatch(a.vendorName, s) ||
                searchForMatch(a.title, s)
            );
        });

        setResPacket(arr1);
    };
    const handleReportSearch = (reportName) => {
        setLoading(true);
        var request = {
            startDate: startDate,
            endDate: endDate,
        };
        var requestObj = {
            startDate: startDate,
            endDate: endDate,
            organisationId: "e432a5cf-c0bb-4d42-9690-d17fe6da68dc",
        };
        let payloadcutomsalesandorderdispatch = {
            startDate: startDate,
            endDate: endDate,
            warehouseId: ware.value === "All" ? "e432a5cf-c0bb-4d42-9690-d17fe6da68dc" : ware?.value || ""

        }
        let monthlySalesPayload = {
            startDate: startDate,
            endDate: endDate,
            warehouseId: ware.value === "All" ? "" : ware?.value || "",
            categoryId: selectedCategory?.value || ""
        }


        // if (item.value && reportName === "Purchases by Item") {
        //     request.itemId = item.value;
        // }
        if (reportName === "SalesByItems" || reportName === "PurchaseByItem") {
            if (!ware?.value || ware?.value === "") {
                toast("Please select warehouse");
                setLoading(false);
                return;
            }
        }

        if (reportName === "SalesByItems") {
            // if (!item.value && !hsn.value) {
            //     toast("Please select HSN or Item");
            //     return;
            // }
            request.warehouseId = ware.value === "All" ? "e432a5cf-c0bb-4d42-9690-d17fe6da68dc" : ware?.value || "";
            request.hsnId = hsn?.value ? hsn?.value : "";
            request.itemId = item?.value ? item?.value : "";
            request.customerId = selectedCustomer?.value === "All" ? "" : selectedCustomer?.value;
            request.customerCategoryId = selectedCustomerCategory?.value === "All" ? "" : selectedCustomerCategory?.value;
        }

        if (reportName === "PurchaseByItem") {
            request.warehouseId = ware.value === "All" ? "e432a5cf-c0bb-4d42-9690-d17fe6da68dc" : ware?.value || ""
            request.hsnId = "";
            request.itemId = item?.value ? item?.value : "";
        }

        // if (reportName === "StockReport") {
        //     request = {
        //         warehouseId : ware?.value
        //     }
        // }

        let data = {
            page: 0,
            search: "",
            size: -1,
        };

        if (reportName === "IssuanceReport") {
            request.warehouseId = ware?.value;
            getIssuanceReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );

        }
        if (reportName === "ProductionSummary") {
            request.warehouseId = ware?.value == "All" ? null : ware?.value
            getBatchesReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            )
        }
        if (reportName === "Customer PriceList") {
            customerPriceList(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "Vendor PriceList") {
            vendorPriceList(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "SalesByItems") {
            getHSNReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "PurchaseByItem") {
            getPurchaseReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "SalesByCustomer") {
            getSalesOrderByCustomerId1(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "SalesBySalesPerson") {
            getSalesOrderBySalesPersonId1(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "GRNByVender") {
            getBillByVendorId1(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        // if (reportName === "Purchases by Item") {
        //     getPurchaseOrderByItemId1(request).then((res) => handleApiResponse(res.responsePacket));
        // }
        if (reportName === "PurchaseByVender") {
            getPurchaseOrderByVendorId1(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "SalesByInvoice") {
            getInvoiceDetailReport1(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "BelowReorderPoint") {
            data.uuid = ware?.value || "";
            data.categoryUuid = selectedCategory?.value || null;
            data.subCategoryUuid = selectedSubCategory?.value || null;
            getBelowOrderLevelItemReport1(data).then((res) =>
                handleApiResponse(res.responsePacket.data)
            );
        }
        if (reportName === "BelowOrderLimitSetPoint") {
            data.uuid = ware?.value || "";
            data.categoryUuid = selectedCategory?.value || "-1";
            getBelowOrderLimitSetPointReport(data).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "Records By Department") {
            getRecordByDepartmentId1(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "InventorySummary") {
            const todaysDate = new Date().toISOString().split("T")[0];
            request.startDate = todaysDate;
            request.endDate = todaysDate;
            request.warehouseList = multiware.map(warehouse => warehouse.value);
            request.categoryId = selectedCategory?.value || "";
            // Store filter only applies with a single warehouse; blank = all stores (SP path).
            request.storeId = multiware.length === 1 ? (selectedStore?.value || "") : "";
            getInventorySummary1(request).then((res) =>
                handleApiResponse(res.responsePacket?.data)
            );
        }
        if (reportName === "SalesReports") {
            itemPriceListReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "SalesByCreditNotes") {
            SalesByCreditNotes(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "ConsumptionVsCurrentStock") {
            consumptionVsCurrentStock(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "HsnReport") {
            HsnReport(request).then((res) => handleApiResponse(res.responsePacket));
        }
        if (reportName === "CrHsnReport") {
            CreditHsnReport(request).then((res) => handleApiResponse(res.responsePacket));
        }
        if (reportName === "StockTransferReports") {
            stockTransferReport(ware?.value).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "PurchaseReports") {
            request.warehouseId = ware?.value === "All" ? "" : ware?.value;
            purchaseProjectionReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }

        if (reportName === "IssueReports") {
            request.warehouseId = ware?.value === "All" ? null : ware?.value;
            issueReport(request).then((res) => handleApiResponse(res.responsePacket));
        }

        if (reportName === "RequisitionReport") {
            request.warehouseId = ware?.value === "All" ? null : ware?.value;
            requisitionReport(request).then((res) => handleApiResponse(res.responsePacket));
        }

        if (reportName === "SalesMarginReport") {
            request.warehouseId = ware?.value === "All" ? "" : ware?.value || "";
            request.categoryIds = (marginCategories || []).map((c) => c.value).filter(Boolean);
            getSalesMarginReport(request).then((res) => handleApiResponse(res.responsePacket || []));
        }

        if (reportName === "GRNReport") {
            request.organisationId = org?.value;
            grnReport(request).then((res) => handleApiResponse(res.responsePacket));
        }

        if (reportName === "StockReport") {
            let data = {
                categoryId: selectedCategory?.value,
                warehouseId: ware?.value || "e432a5cf-c0bb-4d42-9690-d17fe6da68dc"
            }
            stockReport(data).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "StockHistory") {
            let data = {
                warehouseId: ware?.value || "e432a5cf-c0bb-4d42-9690-d17fe6da68dc",
                organisationId: org?.value || "59741534-b41f-4cfc-82a0-d44a176d7229",
                startDate: targetDate
            }
            stockHistory(data).then((res) =>
                handleApiResponse(res.responsePacket?.stockStatus?.[0]?.items)
            )
                .catch((err) => {
                    toast.error("Something went wrong")
                    handleApiResponse([])
                });
        }
        if (reportName === "WipReport") {
            request.organisationId = org?.value;
            request.departmentId = dept?.value;
            request.warehouseId = ware?.value;
            wipReport(request).then((res) => handleApiResponse(res.responsePacket));
        }
        if (reportName === "OthersVsSoh") {
            request.warehouseId = ware?.value;
            deficitReport(request).then((res) => {
                let data = res.responsePacket;
                if (selectedCategory?.value) {
                    data = data?.filter((item) => item.category === selectedCategory.label);
                }
                handleApiResponse(data);
            });
        }
        if (reportName === "PendingPurchaseOrderByVender") {
            pendingPurchaseOrderByVendor(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "PendingSalesOrderByCustomer") {
            pendingSalesOrderByCustomer(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "OrdersVsDispatch") {
            getOrderVsDispatch(payloadcutomsalesandorderdispatch).then((res) => {
                handleApiResponse(res.responsePacket.data)
            })

        }
        if (reportName === "SalesCustom") {
            getCustomSales(payloadcutomsalesandorderdispatch).then((res) => {
                handleApiResponse(res.responsePacket.data)
            })

        }
        if (reportName === "FgItemsReport") {
            GetFgItemsReports(targetDate).then((res) => {
                handleApiResponse(res.responsePacket.data)
            })


        }
        if (reportName === "monthlySalesByCustomer") {
            monthlySalesPayload.priceListId = selectedPrice?.value
            getMonthlySalesByCustomer(monthlySalesPayload).then((res) => {
                handleApiResponse(res.responsePacket.data?.[0])
            })
        }
        if (reportName === "monthlySoldItems") {
            monthlySalesPayload.priceListId = selectedPrice?.value
            getMonthlySoldItemsWithQuantity(monthlySalesPayload).then((res) => {
                handleApiResponse(res.responsePacket.data?.[0])
            })
        }
        if (reportName === "StockTransferByItem") {
            request.fromWarehouseId = fromWare?.value === "All" ? "" : fromWare?.value || "";
            request.toWarehouseId = toWare?.value === "All" ? "" : toWare?.value || "";
            request.itemId = "";
            stockTransferByItemReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
        if (reportName === "NonMovingItems") {
            const range = getNonMovingRange();
            request.startDate = range.startDate;
            request.endDate = range.endDate;
            request.warehouseId = ware?.value === "All" ? "" : ware?.value || "";
            request.categoryId = selectedCategory?.value || "";
            nonMovingItemReport(request).then((res) =>
                handleApiResponse(res.responsePacket)
            );
        }
    };

    const handleApiResponse = (response) => {
        setLoading(false);
        setResPacket(response);
        setRows(response);
    };

    const handleReportType = (reportType) => {
        setReportName(reportType);
        setResPacket([]);
        // if (reportType === "BelowReorderPoint") {
        //     handleReportSearch(reportType);
        // }
        handleReportSearch(reportType);
        setItem({
            label: "Select Item",
            value: "",
        });
    };

    useEffect(() => {
        if (reportName !== "SalesMarginReport" || !orgDetail?.recordId) return;
        callGetAxios(GET_WAREHOUSE_BY_ORG_ID.replaceAll("{uuid}", orgDetail.recordId), "ownOrganisationWarehouses").then((response) => {
            if (response.errorCode !== 0) {
                toast.error(response.message);
                return;
            }
            const options = (response.responsePacket || []).map((item) => ({ label: item.value, value: item.key }));
            // Kesri first, same as the other warehouse lists.
            options.sort((a, b) => (a.label === "Kesri" ? -1 : b.label === "Kesri" ? 1 : 0));
            setMarginWareOptions(options);
            // Keep the current selection only if it is one of these warehouses (or All).
            setWare((prev) => (prev?.value === "All" || options.some((o) => o.value === prev?.value)) ? prev : (options[0] || { label: "All", value: "All" }));
        });
    }, [reportName]);

    const handleOrganizationSelect = (e) => {
        setOrg(e);
        if (reportName === "WipReport" || reportName === "StockHistory") {
            callGetAxios(
                GET_WAREHOUSE_BY_ORG_ID.replaceAll("{uuid}", e.value),
                "warehousesByOrgId"
            ).then((response) => {
                if (response.errorCode === 0) {
                    const res = response.responsePacket;
                    const _res = res.map((item) => ({
                        label: item.value,
                        value: item.key,
                    }));
                    setWareOptions(_res);
                    if (_res.length > 0) {
                        setWare(_res[0]);
                    } else {
                        setWare({
                            label: "No Warehouse",
                            value: "",
                        });
                    }
                    setSelectWarehouse(false);
                }
            });
        } else {
            setSelectWarehouse(false);
        }
    };

    const handleWarehouseSelect = (e) => {
        setWare(e);
        setSelectDepartment(false);
    };

    const handleWareOptions = (e) => {
        const selectedOptions = Array.isArray(e) ? e : [e];
        setMultiware(selectedOptions);
    }

    const canShowStartEndDates =
        reportName !== "NonMovingItems" &&
        reportName !== "InventorySummary" &&
            reportName !== "BelowReorderPoint" &&
            reportName !== "BelowOrderLimitSetPoint" &&
            reportName !== "ConsumptionVsCurrentStock" &&
            reportName !== "StockReport" &&
            reportName !== "StockHistory" &&
            reportName !== "OthersVsSoh" &&
            reportName !== "WipReport" &&
            reportName !== "StockTransferReports" &&
            reportName !== "palleteOccupacy" &&
            reportName !== "customerFssai" &&
            reportName !== "customerCategoryDiscount" &&
            reportName !== "FgItemsReport"
            ? true
            : false;

    const canShowWarehouseSelection = reportName === "NonMovingItems" ||
        reportName === "IssuanceReport" ||
        reportName === "PurchaseReports" ||
        reportName === "IssueReports" ||
        reportName === "SalesByItems" ||
        reportName === "PurchaseByItem" ||
        reportName === "SalesMarginReport" ||
        reportName === "OthersVsSoh" ||
        reportName === "BelowReorderPoint" ||
        reportName === "BelowOrderLimitSetPoint" ||
        reportName === "StockReport" ||
        reportName === "StockHistory" ||
        reportName === "WipReport" ||
        reportName == "StockTransferReports" ||
        reportName === "palleteOccupacy" ||
        reportName === "OrdersVsDispatch" || reportName === "SalesCustom" || reportName === "monthlySalesByCustomer" || reportName === "monthlySoldItems"
        || reportName === "ProductionSummary" || reportName === "RequisitionReport"
        ? true
        : false;

    const canShowMultiWarehouseSelection = reportName === "InventorySummary" ? true : false;

    const canShowFromToWarehouseSelection = reportName === "StockTransferByItem";

    const canShowDepartmentSelection = reportName === "WipReport" ? true : false;
    const canShowOrgSelection = reportName === "WipReport" || reportName === "GRNReport" || reportName == "StockHistory" ? true : false;
    const canShowStoreOptions = reportName === "palleteOccupacy" || reportName === "InventorySummary"
    // Inventory Summary: a store belongs to one warehouse, so the store filter needs exactly one warehouse selected.
    const storeFilterLocked = reportName === "InventorySummary" && multiware.length !== 1
    const canShowCustomerList = reportName === "SalesByItems"
    const canShowSelectDate = reportName === "FgItemsReport" || reportName === "StockHistory";
    const canShowPriceList = reportName === "monthlySalesByCustomer" || reportName === "monthlySoldItems"


    return (
        <>
            <div className="px-3">
                <div className=" flex-wrap row2 py-3">
                    <h3 className="mb-0 font-size-18 font-weight-bolder text-uppercase">
                        Reports
                    </h3>
                    {canShowCustomerList && (
                        <div className="row1">
                            {customerCategoryOptions && (
                                <Select
                                    id="customerCategorySelect"
                                    placeholder="Select Customer Category"
                                    value={selectedCustomerCategory}
                                    onChange={(e) => {
                                        setSelectedCustomerCategory(e);
                                        setSelectedCustomer({ label: "All", value: "All" });
                                        if (!e?.value || e.value === "All") {
                                            customerAllRecords();
                                        } else {
                                            customerRecordsByCategory(e.value);
                                        }
                                    }}
                                    options={[{ label: "All", value: "All" }, ...customerCategoryOptions]}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minWidth: '200px',
                                            marginRight: '15px',
                                        }),
                                    }}
                                />

                            )}
                            {customerListOptions && (
                                <Select
                                    id="reportSelect"
                                    placeholder="Select Customer"
                                    value={selectedCustomer}
                                    onChange={(e) => {
                                        setSelectedCustomer(e);
                                    }}
                                    options={[{ label: "All", value: "All" }, ...customerListOptions]}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minWidth: '200px',
                                        }),
                                    }}
                                />

                            )}
                        </div>
                    )}

                    <div className="row1">

                        {canShowStartEndDates && (
                            <>
                                <div className="input-group searchInput dateInput mr-3">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text font-weight-bold"
                                            id="basic-addon1"
                                        >
                                            Start:
                                        </span>
                                    </div>
                                    <input
                                        autoComplete="off"
                                        className=" form-control"
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>
                                <div className="input-group searchInput dateInput mr-3">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text font-weight-bold"
                                            id="basic-addon1"
                                        >
                                            End:
                                        </span>
                                    </div>
                                    <input
                                        autoComplete="off"
                                        className=" form-control"
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>
                            </>
                        )}
                        {reportName === "NonMovingItems" && (
                            <div className="mx-2" style={{ minWidth: "170px" }}>
                                <Select
                                    id="reportSelect"
                                    placeholder="Select Days"
                                    value={nonMovingDays}
                                    onChange={(e) => setNonMovingDays(e)}
                                    options={nonMovingDaysOptions}
                                />
                            </div>
                        )}

                        {orgDetail?.isDefault && canShowOrgSelection && (
                            <div className="mx-2">
                                {orgOptions && (
                                    <Select
                                        id="reportSelect"
                                        placeholder="Select Organization"
                                        value={org}
                                        onChange={(e) => handleOrganizationSelect(e)}
                                        options={orgOptions}
                                    />
                                )}
                            </div>
                        )}

                        {canShowWarehouseSelection && (
                            <div className="mx-2">
                                {wareOptions && (
                                    <Select
                                        id="reportSelect"
                                        placeholder="Select Warehouse"
                                        value={ware}
                                        onChange={(e) => {
                                            handleWarehouseSelect(e);
                                        }}
                                        options={
                                            reportName === "SalesMarginReport"
                                                ? [{ label: "All", value: "All" }, ...marginWareOptions]
                                                : (reportName === "RequisitionReport" || reportName === "monthlySoldItems" || reportName === "monthlySalesByCustomer" || reportName === "IssueReports" || reportName === "PurchaseReports" || reportName === "ProductionSummary")
                                                    ? [{ label: "All", value: "All" }, ...wareOptions]
                                                    : wareOptions
                                        }
                                        isDisabled={
                                            (reportName === "WipReport" || reportName === "StockHistory") ? selectWarehouse : false
                                        }
                                    />
                                )}
                            </div>
                        )}
                        {canShowStoreOptions && (
                            <div className="mx-2">
                                {storeOption && (
                                    <Select
                                        id="reportSelect"
                                        placeholder={storeFilterLocked ? "Select one warehouse for store filter" : "Select Store"}
                                        value={selectedStore}
                                        onChange={(e) => {
                                            setSelectedStore(e);
                                        }}
                                        options={storeOption}
                                        isDisabled={
                                            reportName === "InventorySummary" ? storeFilterLocked : !ware?.value
                                        }
                                    />
                                )}
                            </div>
                        )}

                        {canShowFromToWarehouseSelection && (
                            <>
                                <div className="mx-2 d-flex align-items-center">
                                    <span className="font-weight-bold mr-2">From:</span>
                                    {wareOptions && (
                                        <Select
                                            id="reportSelect"
                                            placeholder="From Warehouse"
                                            value={fromWare}
                                            onChange={(e) => setFromWare(e)}
                                            options={[{ label: "All", value: "All" }, ...wareOptions]}
                                        />
                                    )}
                                </div>
                                <div className="mx-2 d-flex align-items-center">
                                    <span className="font-weight-bold mr-2">To:</span>
                                    {wareOptions && (
                                        <Select
                                            id="reportSelect"
                                            placeholder="To Warehouse"
                                            value={toWare}
                                            onChange={(e) => setToWare(e)}
                                            options={[{ label: "All", value: "All" }, ...wareOptions]}
                                        />
                                    )}
                                </div>
                            </>
                        )}

                        {canShowMultiWarehouseSelection && (
                            <div className="mx-2">
                                <Select
                                    id="reportSelect"
                                    placeholder="Select Warehouse"
                                    value={multiware}
                                    onChange={(e) => {
                                        handleWareOptions(e);
                                    }}
                                    options={multiWareOptions}
                                    isMulti={true}
                                    className="multiWarehouseCustom zIndex4 d-flex"
                                />
                            </div>
                        )}

                        {canShowDepartmentSelection && (
                            <div className="mx-2">
                                {deptOptions && (
                                    <Select
                                        id="reportSelect"
                                        placeholder="Select Department"
                                        value={dept}
                                        onChange={(e) => setDept(e)}
                                        options={deptOptions}
                                        isDisabled={
                                            reportName === "WipReport" ? selectDepartment : false
                                        }
                                    />
                                )}
                            </div>
                        )}
                        {canShowSelectDate && (
                            <div className="input-group searchInput dateInput mr-3">
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text font-weight-bold"
                                        id="basic-addon1"
                                    >
                                        Target Date:
                                    </span>
                                </div>
                                <input
                                    autoComplete="off"
                                    className=" form-control"
                                    type="date"
                                    value={targetDate}
                                    onChange={(e) => setTargetDate(e.target.value)}
                                />
                            </div>
                        )}

                        {/* {reportName === "WipReport" && (
                            <div className="mx-2">{orgOptions && <Select id="reportSelect" placeholder="Select Organization" value={org} onChange={(e) => { setOrg(e); setSelectWarehouse(false) }} options={orgOptions} />}</div>
                        )} */}

                        {/* {reportName === "Purchases by Item" && (
                            <div className="mx-2">{itemOptions && <Select id="reportSelect" placeholder="Select Item" value={item} onChange={(e) => setItem(e)} options={itemOptions} />}</div>
                        )} */}
                        {/* {reportName === "SalesByItems" && (
                            <div className="mx-2">{hsnOptions && <Select id="reportSelect" placeholder="Select HSN" value={hsn} onChange={(e) => setHsn(e)} options={hsnOptions} />}</div>
                        )} */}
                        {reportName === "SalesMarginReport" && (
                            <div className="mx-2">
                                <Select
                                    id="reportSelect"
                                    placeholder="All Categories"
                                    value={marginCategories}
                                    onChange={(e) => setMarginCategories(Array.isArray(e) ? e : [])}
                                    options={(categoryOptions || []).filter((c) => c.value)}
                                    isMulti={true}
                                    closeMenuOnSelect={false}
                                    className="multiWarehouseCustom zIndex4 d-flex"
                                    maxMenuHeight={220}
                                />
                            </div>
                        )}
                        {(reportName === "NonMovingItems" || reportName === "InventorySummary" || reportName === "StockReport" || reportName === "monthlySoldItems" || reportName === "monthlySoldItems" || reportName === "BelowReorderPoint" || reportName === "OthersVsSoh" || reportName === "BelowOrderLimitSetPoint") && (
                            <div className="mx-2">
                                {hsnOptions && categoryOptions && (
                                    <Select
                                        id="reportSelect"
                                        options={categoryOptions}
                                        placeholder={"Select Category"}
                                        onChange={(e) => setSelectedCategory(e)}
                                        value={selectedCategory}
                                        maxMenuHeight={220}
                                    />
                                )}
                            </div>
                        )}
                        {(reportName === "BelowReorderPoint") && (
                            <div className="mx-2">
                                {hsnOptions && subCategoryOptions && (
                                    <Select
                                        id="reportSelect"
                                        options={subCategoryOptions}
                                        placeholder={"Select Category"}
                                        onChange={(e) => setSelectedSubCategory(e)}
                                        value={selectedSubCategory}
                                        maxMenuHeight={220}
                                    />
                                )}
                            </div>
                        )}
                        {canShowPriceList && (
                            <div className="mx-2">
                                {priceListOpt && (
                                    <Select
                                        id="reportSelect"
                                        placeholder="Select Price"
                                        value={selectedPrice}
                                        onChange={(e) => setSelectedPrice(e)}
                                        options={priceListOpt}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minWidth: '200px',
                                            }),
                                        }}
                                    />
                                )}
                            </div>
                        )
                        }
                    </div>
                    {(reportName !== "ConsumptionVsCurrentStock" && reportName !== "palleteOccupacy" && reportName !== "customerFssai" && reportName !== "customerCategoryDiscount") && (
                        <Button
                            className="btn btn-primary font-size-14 py-2 text-light"
                            onClick={() => handleReportSearch(reportName)}
                        >
                            Search
                        </Button>
                    )}
                    <div className="row1">
                        {/* <div className="input-group searchInput mr-3 listSearch reportSearch"></div> */}
                        <div className="input-group mr-3 paginationSearchInput">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="basic-addon1">
                                    <SearchRoundedIcon />
                                </span>
                            </div>
                            <input
                                autoComplete="off"
                                className="form-control"
                                type="text"
                                placeholder="Search here"
                                onChange={(e) => handleSearchData(e.target.value)}
                            />
                        </div>
                        {/* <button
              className="btn hoverBtn p-1 mr-2"
              onClick={handlePrint}
            // onClick={handlePrintExcel}
            >
              <LocalPrintshopOutlinedIcon style={{ fontSize: '22px' }} />
            </button> */}
                        <button
                            className="btn hoverBtn p-1"
                            // onClick={handlePrint}
                            onClick={handlePrintExcel}
                        >
                            <AssessmentIcon style={{ fontSize: '22px' }} />

                        </button>
                    </div>
                </div>
                <hr className="commonHR mt-0" />
                <div className="row w-100">
                    {/* <div className="col-3"> */}
                    {/* <div className="custom-report-height"> */}
                    {/* <div className="reportTypes ">
                {reportOptionsList.map((data, i) => (
                  <table className="reportTable" key={i}>
                    <thead>
                      <tr>
                        <th>
                          <span>
                            <i className="fa fa-shopping-cart mr-2"></i>
                          </span>
                          {data.title}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.reportTypes.map((type, j) => {
                        if (urlList.has(type.serverUrl) || isSuperAdmin) {
                          return (
                            <tr
                              key={j}
                              onClick={() => handleReportType(type.name)}
                              className="reportTr"
                            >
                              <td
                                className={`${type.name === reportName ? "activeReport" : ""
                                  }`}
                              >
                                {/* {type.icon} */}
                    {/* <ChevronRightIcon />
                                {type.name}
                              </td>
                            </tr>
                          );
                        } else return null;
                      })}
                    </tbody>
                  </table>
                ))}
              </div> */}
                    {/* </div> */}
                    {/* </div> */}
                    <div className="col-12 custom-table-height">
                        <div
                            className="custom-table-div standardTable"
                            ref={componentRef}
                            id="pdf"
                            style={{ width: "100%", margin: "15px", color: "black" }}
                        >
                            {loading ? (
                                <Loader />
                            ) : (
                                <>
                                    <div className="d-flex justify-content-between px-2">
                                        <div style={{ fontSize: "18px", fontWeight: "500" }}>
                                            {reportName === "OthersVsSoh" ? "PO vs Stock In Hand" : reportName === "OrdersVsDispatch" ? "Variance Report" : reportName
                                                .replace(/([a-z])([A-Z])/g, '$1 $2')
                                                .replace(/^./, (char) => char.toUpperCase())
                                            }
                                        </div>
                                        {reportName === "NonMovingItems" && (
                                            <div className="d-flex justify-content-end align-items-center">
                                                <span className="mr-5">{nonMovingDays?.label}</span>
                                                <span className="mr-5">From: {getNonMovingRange().startDate}</span>
                                                <span>To: {getNonMovingRange().endDate}</span>
                                            </div>
                                        )}
                                        {(reportName === "SalesByItems" ||
                                            reportName === "StockTransferByItem" ||
                                            reportName === "SalesMarginReport" ||
                                            reportName === "PurchaseByItem") && (
                                                <div className="d-flex justify-content-end align-items-center">
                                                    <span className="mr-5">Start Date: {startDate}</span>
                                                    <span>End Date: {endDate}</span>
                                                </div>
                                            )}
                                    </div>
                                    <hr style={{ borderTop: "1px solid #ececec" }} />

                                    {(reportName === "SalesByCustomer" ||
                                        reportName === "SalesBySalesPerson") && (
                                            <SalesByCustomer resPacket={resPacket} />
                                        )}
                                    {reportName === "SalesByInvoice" && (
                                        <SalesByInvoice resPacket={resPacket} />
                                    )}
                                    {(reportName === "PurchaseByVender" ||
                                        reportName === "GRNByVender") && (
                                            <PurchaseByVendor
                                                resPacket={resPacket}
                                                reportName={reportName}
                                            />
                                        )}
                                    {reportName === "BelowReorderPoint" && (
                                        <BelowReorderPoint
                                            resPacket={resPacket}
                                            reportName={reportName}
                                            warehouse={ware}
                                        />
                                    )}
                                    {reportName === "BelowOrderLimitSetPoint" && (
                                        <BelowOrderLimitReport resPacket={resPacket} />
                                    )}
                                    {reportName === "InventorySummary" && (
                                        <InventorySummary resPacket={resPacket} warehouse={multiware} storeId={multiware.length === 1 ? (selectedStore?.value || "") : ""} />
                                    )}
                                    {reportName === "IssuanceReport" && (
                                        <IssuanceReport resPacket={resPacket} />
                                    )}
                                    {reportName === "Records By Department" && (
                                        <RecordsByDepartment resPacket={resPacket} />
                                    )}
                                    {reportName === "ProductionSummary" && (
                                        <ProductionSummary resPacket={resPacket} />
                                    )}
                                    {reportName === "Customer PriceList" && (
                                        <CustomerPriceListReport
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    )}
                                    {reportName === "Vendor PriceList" && (
                                        <VendorPriceListReport
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    )}
                                    {reportName === "Stock Closing Report" && (
                                        <ReportStockClosing resPacket={resPacket} />
                                    )}
                                    {reportName === "SalesByItems" && (
                                        <HSNReport
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                            warehouse={ware}
                                            customer={selectedCustomer?.value || "fbc7f588-3668-4290-963f-682886aa772f"}
                                            customerCategory={selectedCustomerCategory?.value === "All" ? "" : selectedCustomerCategory?.value}
                                        />
                                    )}
                                    {reportName === "PurchaseByItem" && (
                                        <PurchaseReport
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                            warehouse={ware}
                                        />
                                    )}
                                    {reportName === "SalesReports" && (
                                        <ItemPriceList resPacket={resPacket} loading={loading} />
                                    )}
                                    {reportName === "SalesByCreditNotes" && (
                                        <SalesByCreditNotesReport
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    )}
                                    {reportName === "ConsumptionVsCurrentStock" && (
                                        <ConsumptionReport resPacket={resPacket} />
                                    )}
                                    {reportName === "HsnReport" && (
                                        <HReport
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    )}
                                    {reportName === "CrHsnReport" && (
                                        <CRHSN
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    )}
                                    {reportName === "PurchaseReports" && (
                                        <PurchaseProjection
                                            resPacket={resPacket}
                                            loading={loading}
                                        />
                                    )}

                                    {reportName === "IssueReports" && (
                                        <IssueReport resPacket={resPacket} loading={loading} />
                                    )}

                                    {reportName === "RequisitionReport" && (
                                        <RequisitionReport resPacket={resPacket} loading={loading} />
                                    )}

                                    {reportName === "GRNReport" && (
                                        <GrnReport resPacket={resPacket} loading={loading} excelExport={excelExport} />
                                    )}

                                    {reportName === "SalesMarginReport" && (
                                        <SalesMarginReport resPacket={resPacket} loading={loading} />
                                    )}

                                    {reportName === "StockReport" && (
                                        <StockReport
                                            resPacket={resPacket}
                                            loading={loading}
                                            warehouse={ware}
                                            department={dept}
                                        />
                                    )}
                                    {reportName === "StockHistory" && (
                                        <StockHistory resPacket={resPacket} loading={loading} />
                                    )}
                                    {reportName === "StockTransferByItem" && (
                                        <StockTransferByItem
                                            resPacket={resPacket}
                                            startDate={startDate}
                                            endDate={endDate}
                                            fromWarehouse={fromWare}
                                            toWarehouse={toWare}
                                        />
                                    )}
                                    {reportName === "NonMovingItems" && (
                                        <NonMovingItems resPacket={resPacket} />
                                    )}
                                    {reportName === "StockTransferReports" && (
                                        <StockTransferReports
                                            resPacket={resPacket}
                                            loading={loading}
                                            warehouse={ware}
                                            department={dept}
                                        />
                                    )}
                                    {reportName === "WipReport" && (
                                        <WipReport
                                            resPacket={resPacket}
                                            loading={loading}
                                            warehouse={ware}
                                            department={dept}
                                        />
                                    )}
                                    {reportName === "OthersVsSoh" && (
                                        <DeficitReport resPacket={resPacket} warehouse={ware} />
                                    )}
                                    {reportName === "PendingSalesOrderByCustomer" && (
                                        <PendingSalesOrderByCustomer resPacket={resPacket} />
                                    )}
                                    {reportName === "PendingPurchaseOrderByVender" && (
                                        <PendingPurchaseOrderByVendor
                                            resPacket={resPacket}
                                            warehouse={ware}
                                        />
                                    )}
                                    {reportName === "palleteOccupacy" && (
                                        <PalleteOccupancy resPacket={resPacket} />
                                    )}
                                    {reportName === "customerFssai" && (
                                        <CustomerFssaiReport resPacket={resPacket} />
                                    )}
                                    {reportName === "customerCategoryDiscount" && (
                                        <CustomerCategoryDiscountReport resPacket={resPacket} />
                                    )}
                                    {reportName === "SalesCustom" && (
                                        <SalesCustom resPacket={resPacket} />
                                    )}
                                    {reportName === "OrdersVsDispatch" && (
                                        <OrdersVsDispatch resPacket={resPacket} />
                                    )}
                                    {reportName === "FgItemsReport" && (
                                        <FgItemsReport resPacket={resPacket} />
                                    )}
                                    {reportName === "monthlySalesByCustomer" && (
                                        <MonthlySalesByCustomer startDate={startDate} endDate={endDate} resPacket={resPacket} />
                                    )}
                                    {reportName === "monthlySoldItems" && (
                                        <MonthlySoldItems startDate={startDate} endDate={endDate} resPacket={resPacket} />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default ViewReports;
